import { ResponseColumnHeader } from '@/js/services/api/interaction/types';
import { useSectionColor } from '@/js/composables/useSectionColor';

const { getCardAccentColor } = useSectionColor();

const sortColumns = (a: ResponseColumnHeader, b: ResponseColumnHeader) => {
    if (a.order == null && b.order == null) return 0;
    if (a.order == null) return 1;
    if (b.order == null) return -1;
    return a.order - b.order;
};

export function createProtocolTableColumns(newColumns: ResponseColumnHeader[]) {
    const expandedCols: Record<
        string,
        { open: boolean; children: ResponseColumnHeader[]; column?: ResponseColumnHeader }
    > = {};
    // Build a map of parent columns to their children
    const expandableRootColumns: ResponseColumnHeader[] = [];
    newColumns.forEach((col) => {
        if (col.expandsFromParentId) {
            if (!expandedCols[col.expandsFromParentId]) {
                expandedCols[col.expandsFromParentId] = { open: false, children: [] };
            }
            expandedCols[col.expandsFromParentId].children.push(col);
        }
    });
    // Assign columns to the map and collect root expandable columns
    newColumns.forEach((col) => {
        if (expandedCols[col.id]) {
            expandedCols[col.id].children.sort(sortColumns);
            if (!col.expandsFromParentId) {
                expandableRootColumns.push(col);
            }
        }
    });

    const regularColumns = newColumns.filter((c) => !c.expandsFromParentId && !expandedCols[c.id]);

    const topLevelColumns = [...regularColumns, ...expandableRootColumns].sort(sortColumns);

    const columns: ResponseColumnHeader[] = [];

    topLevelColumns.forEach((col) => {
        columns.push(col);

        if (expandedCols[col.id]) {
            expandedCols[col.id].children.forEach((childCol, index) => {
                const sectionColor = getCardAccentColor(Number(index));
                columns.push({ ...childCol, color: sectionColor });

                if (expandedCols[childCol.id]) {
                    expandedCols[childCol.id].children.forEach((grandChildCol) => {
                        columns.push({ ...grandChildCol, color: sectionColor });
                    });
                }
            });
        }
    });

    return { columns, expandedColumns: expandedCols };
}
